module.exports = __webpack_public_path__ + "img/ill2.3ec2157f.svg";